import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'colorSketchInputVarName',
})
export class ColorSketchInputVarNamePipe implements PipeTransform {
  constructor() {}
  transform(value: string, presetColors: any[]): string {
    if (!value) {
      return '';
    }
    // shows preset descriptions (including “From Global styles”) for non-var() values.
    const preset = presetColors?.find(config => config?.value === value);
    if (preset?.description) {
      return preset.description;
    }
    // 'match' detect var(...) syntax
    const pattern = /^var\(\s*(--[^,)\s]+)\s*(?:,.*)?\)$/;
    const match = pattern.exec(value);

    if (!match) {
      return value;
    }

    return '';
  }
}
